"use client";

import { AmenityCategory } from "@/types/AmenityCategory";
import { useState } from "react";
import AmenityList from "../AmenityList";
import AmenityListModal from "../AmenityListModal";
import "./index.scss";

const FeaturedAmenities = ({
  featuredAmenities,
  amenityCategories,
}: {
  featuredAmenities: string[];
  amenityCategories: AmenityCategory[];
}) => {
  const [isAmenityListModalOpened, setIsAmenityListModalOpened] =
    useState(false);

  if (featuredAmenities.length === 0) {
    return null;
  }

  let numberOfAmenities = 0;
  amenityCategories.forEach((category) => {
    numberOfAmenities += category.amenities.length;
  });

  return (
    <div className="component featured-amenities">
      <div className="featured-amenities-inner-wrapper">
        <AmenityList name="What we offer" amenities={featuredAmenities} />
        {numberOfAmenities > 10 && (
          <button onClick={() => setIsAmenityListModalOpened(true)}>
            View all {numberOfAmenities} amenities
          </button>
        )}
      </div>
      {isAmenityListModalOpened && (
        <AmenityListModal
          amenityCategories={amenityCategories}
          onClose={() => {
            setIsAmenityListModalOpened(false);
          }}
        />
      )}
    </div>
  );
};

export default FeaturedAmenities;
